import { yupResolver } from '@hookform/resolvers/yup';
import {
  DashboardContainerHeader,
  ScrollContainer,
} from 'app/layout/dashboardLayout/BoxLayout';
import { BusinessProjectGetId } from 'app/services/responseTypes';
import {
  useCreateBusinessProjectMutation,
  useCreateClientBusinessMutation,
  useUpdateBusinessProjectLogoMutation,
} from 'app/services/user';
import { SaveIcon } from 'assets/icons';
import Button from 'Components/Buttons/Button';
import { successToast } from 'Components/Notifications';
import { useEffect, useState } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from 'utils/AuthProvider';
import { BusinessForm } from '../BusinessForm';
import { validationSchema } from './formFields';

export interface IAddBusinessDetailsProps {}

export default function AddBusinessDetails(props: IAddBusinessDetailsProps) {
  const [selectedFile, setSelectedFile] = useState(String);
  const { clientId } = useParams();
  const { isAdmin } = useAuth();
  const [CreateBusinessProject, { isLoading }] =
    useCreateBusinessProjectMutation();
  const [CreateClientBusiness, { isLoading: createClientBusinessLoading }] =
    useCreateClientBusinessMutation();

  let navigate = useNavigate();

  const onSubmit = async (form: BusinessProjectGetId) => {
    const business = {
      ...form,
      business_owners_attributes: form.business_owners,
    };

    if (isAdmin) {
      CreateClientBusiness({ clientId: +clientId!, business })
        .unwrap()
        .then((response) => {
          successToast('New Business Added');
          navigate(
            `/dashboard/clients/${clientId}/businesses/${response.business.id}`,
          );
        });
    } else {
      CreateBusinessProject(business)
        .unwrap()
        .then((response) => {
          successToast('New Business Added');
          navigate(`/dashboard/profile/businesses/${response.business.id}`);
        });
    }
  };

  return (
    <BusinessForm
      isLoading={isLoading || createClientBusinessLoading}
      title={'Add Business'}
      button={
        <>
          Create <SaveIcon className="w-5 h-5" />
        </>
      }
      onSubmit={onSubmit}
    />
  );
}
